import { motion } from "framer-motion";

const people = [
  {
    initials: "PD",
    name: "Patricia Deegan, PhD",
    role: "Fondatrice — Pat Deegan & Associates",
    body: "Pionnière mondiale du rétablissement en santé mentale, créatrice de la Médecine Personnelle et du programme CPMC déployé dans plus de 25 pays.",
    accent: "bg-mint",
  },
  {
    initials: "LV",
    name: "Luc Vigneault",
    role: "Premier pair-aidant en santé mentale au Canada",
    body: "Figure de la pair-aidance québécoise, il anime les modules d'accompagnement par les pairs de cette première cohorte francophone.",
    accent: "bg-sun",
  },
  {
    initials: "MP",
    name: "Melanie Plante",
    role: "CPMC, CPMC-T — Formatrice",
    body: "Certifiée CPMC et CPMC-T directement avec l'équipe de Patricia Deegan, PhD, et formée sur le terrain sous la supervision de Luc Vigneault, premier pair-aidant au Canada, Mélanie apporte une combinaison inédite au Canada : son savoir expérientiel du rétablissement et la formation Nutrition et santé mentale de Dre Uma Naidoo (Massachusetts General Hospital, affiliée à Harvard Medical School), l'une des pionnières de la psychiatrie nutritionnelle. Mélanie anime les modules de nutrition et santé mentale de cette cohorte.",
    accent: "bg-coral/70",
  },
];

export default function Pioneers() {
  return (
    <section className="py-24 sm:py-32">
      <div className="mx-auto max-w-7xl px-5 sm:px-8">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.8, ease: [0.16, 1, 0.3, 1] }}
          className="mb-16 max-w-3xl"
        >
          <p className="mb-4 font-mono text-xs uppercase tracking-[0.3em] text-teal-dark">
            L'alliance
          </p>
          <h2 className="font-display text-3xl font-bold tracking-tight sm:text-4xl lg:text-5xl">
            Deux pionniers mondiaux du rétablissement
          </h2>
          <p className="mt-6 text-base leading-relaxed text-ink/70 sm:text-lg">
            Une formation animée par des pairs aidants certifiés qui ont eux-mêmes
            parcouru le chemin du rétablissement — et qui savent qu'on peut se relever,
            même lorsque tout un système vous dit le contraire.
          </p>
        </motion.div>

        <div className="grid gap-6 md:grid-cols-2">
          {people.slice(0, 2).map((p, i) => (
            <motion.div
              key={p.initials}
              data-testid={`cpmc-pioneer-card-${i + 1}`}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ duration: 0.7, delay: i * 0.12, ease: [0.16, 1, 0.3, 1] }}
              whileHover={{ y: -6 }}
              className="rounded-3xl border border-ink/10 bg-white/70 p-8 shadow-sm backdrop-blur transition-shadow duration-300 hover:shadow-xl"
            >
              <div className={`mb-6 flex h-16 w-16 items-center justify-center rounded-2xl ${p.accent} font-display text-xl font-extrabold text-ink`}>
                {p.initials}
              </div>
              <h3 className="font-display text-xl font-bold">{p.name}</h3>
              <p className="mb-4 mt-1 font-mono text-[10px] uppercase tracking-[0.2em] text-teal-dark">
                {p.role}
              </p>
              <p className="text-sm leading-relaxed text-ink/70">{p.body}</p>
            </motion.div>
          ))}
        </div>

        <motion.div
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          viewport={{ once: true }}
          transition={{ duration: 0.7 }}
          className="my-12 flex items-center gap-5"
        >
          <span className="h-px flex-1 bg-ink/15" />
          <span
            data-testid="cpmc-team-separator"
            className="whitespace-nowrap font-mono text-xs uppercase tracking-[0.3em] text-teal-dark"
          >
            Équipe de Luc Vigneault
          </span>
          <span className="h-px flex-1 bg-ink/15" />
        </motion.div>

        <div className="grid gap-6 lg:max-w-3xl">
          {people.slice(2).map((p, i) => (
            <motion.div
              key={p.initials}
              data-testid={`cpmc-pioneer-card-${i + 3}`}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ duration: 0.7, ease: [0.16, 1, 0.3, 1] }}
              whileHover={{ y: -6 }}
              className="rounded-3xl border border-ink/10 bg-white/70 p-8 shadow-sm backdrop-blur transition-shadow duration-300 hover:shadow-xl"
            >
              <div className={`mb-6 flex h-16 w-16 items-center justify-center rounded-2xl ${p.accent} font-display text-xl font-extrabold text-ink`}>
                {p.initials}
              </div>
              <h3 className="font-display text-xl font-bold">{p.name}</h3>
              <p className="mb-4 mt-1 font-mono text-[10px] uppercase tracking-[0.2em] text-teal-dark">
                {p.role}
              </p>
              <p className="text-sm leading-relaxed text-ink/70">{p.body}</p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
